<template>
  <div class="eui-a-input"
       :class="[{ '-focus': hasFocus }, { '-valid': valid }, { '-warning': warning }, { '-invalid': invalid }, { '-disabled': disabled }, `-${type}`, { '-noIcon': noIcon }]">
    <div class="eui-a-input__startEnhancer" v-if="$slots.startEnhancer">
      <slot name="startEnhancer"></slot>
    </div>
    <div class="eui-a-input__inputContainer">
      <input class="eui-a-input__input"
             ref="input"
             v-on="listeners"
             v-bind="$attrs"
             :type="type"
             :value="value"
             :required="required"
             :disabled="disabled"
             :name="name"
             @focusin="onFocus(true)"
             @focusout="onFocus(false)"
      />
    </div>
    <div class="eui-a-input__endEnhancer" v-if="$slots.endEnhancer">
      <slot name="endEnhancer"/>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Input',
        inheritAttrs: false,
        data () {
          return {
            hasFocus: false,
            isInvalid: undefined,
          };
        },
        methods: {
          onFocus(value) {
            this.hasFocus = value;
          },
        },
        props: {
            type: {
              type: String,
              default: 'text',
            },
            name: {
              type: String,
              default: null
            },
            noIcon: Boolean,
            valid: Boolean,
            invalid: Boolean,
            warning: Boolean,
            required: {
              type: Boolean,
              default: false,
            },
            disabled: {
              type: Boolean,
              default: false,
            },
            value: {
                type: [String, Number],
                default: undefined,
            },
        },

        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                  blur: event => this.$emit("blur", event.target.value),
                  change: event => this.$emit("change", event.target.value),
                  input: event => this.$emit("input", event.target.value),
                  focus: event => this.$emit("focus", event.target.value),
                  contextmenu: event => this.$emit("contextmenu", event.target.value),
                  invalid: event => this.$emit("invalid", event.target.value),
                };
            },
        }
    };
</script>
